import React, { useState, useEffect } from 'react';
import './FloatingShareButton.css';

const FloatingShareButton = () => {
  const [showButton, setShowButton] = useState(false);
  const [showShareMenu, setShowShareMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 300px
      setShowButton(window.pageYOffset > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const shareUrl = window.location.origin;
  const shareText = "Check out these free PDF tools - convert files & remove pages instantly in your browser! 100% private, no uploads required.";

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Free PDF Tools - Utility Tools',
          text: shareText,
          url: shareUrl
        });
      } catch (err) {
        if (err.name !== 'AbortError') {
          setShowShareMenu(true);
        }
      }
    } else {
      setShowShareMenu(true);
    }
  };

  const shareOnPlatform = (platform) => {
    const encodedText = encodeURIComponent(shareText);
    const encodedUrl = encodeURIComponent(shareUrl);

    const urls = {
      twitter: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}&hashtags=PDFtools,FreePDF,PrivacyFirst`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      whatsapp: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
      telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedText}`
    };

    window.open(urls[platform], '_blank', 'width=600,height=400');
    setShowShareMenu(false);
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(`${shareText} ${shareUrl}`);
      setShowShareMenu(false);
      // Could add a toast notification here
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  if (!showButton) return null;

  return (
    <>
      <button
        className="floating-share-button"
        onClick={handleShare}
        title="Share these PDF tools"
        aria-label="Share PDF tools with others"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"/>
        </svg>
      </button>

      {showShareMenu && (
        <div className="floating-share-menu">
          <div className="floating-share-menu-content">
            <div className="floating-share-header">
              <h4>Share PDF Tools</h4>
              <button
                className="floating-share-close"
                onClick={() => setShowShareMenu(false)}
              >
                ×
              </button>
            </div>

            <div className="floating-share-options">
              <button onClick={() => shareOnPlatform('whatsapp')} className="floating-share-option">
                <span className="floating-share-icon">📱</span>
                WhatsApp
              </button>

              <button onClick={() => shareOnPlatform('telegram')} className="floating-share-option">
                <span className="floating-share-icon">✈️</span>
                Telegram
              </button>

              <button onClick={() => shareOnPlatform('twitter')} className="floating-share-option">
                <span className="floating-share-icon">🐦</span>
                Twitter
              </button>

              <button onClick={() => shareOnPlatform('linkedin')} className="floating-share-option">
                <span className="floating-share-icon">💼</span>
                LinkedIn
              </button>

              <button onClick={copyToClipboard} className="floating-share-option">
                <span className="floating-share-icon">📋</span>
                Copy Link
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingShareButton;